<template>
  <div>
    <a v-if="file" target="_blank" class="btn mr-2 mb-2" :href="file">
      {{ "donwload_file_must" | setText("Скачать документ") }}</a
    >
    <a target="_blank" class="btn mb-2" v-if="signFile" :href="signFile">
      {{ "donwload_file_sign_must" | setText("Договор с подписью") }}</a
    >

    <div>
      <input
        class="btn btn-info mt-4"
        type="file"
        accept="image/*"
        @change="selectFile"
      />
    </div>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "../../../plugins/functions";

export default {
  watch: {},
  components: {
    informator: () => import("./Informator"),
  },

  computed: {
    signFile() {
      let file = "";
      if (
        this.transaction.pre_api_result &&
        this.transaction.pre_api_result["url"]
      ) {
        file = this.transaction.pre_api_result["url"].replace(/\?.*$/, "");
      } else if (this.value && this.value["url"]) {
        file = this.value["url"];
      }

      return file;
    },
    file() {
      let file = "";
      if (
        this.transaction.api_result &&
        this.transaction.api_result["file_url"]
      ) {
        file = this.transaction.api_result["file_url"].replace(/\?.*$/, "");
      } else if (this.value && this.value["file_url"]) {
        file = this.value["file_url"];
      }

      return file;
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  created() {
    this.data["loan_id"] = this.transaction["exchange_id"];
  },
  name: "filter",

  methods: {
    send() {
      this.$loading(true);
      let contentType = "multipart/form-data";
      let data = toFormData(this.data);
      let link = `send-signed-contract`;
      this.$http({
        url: `${this.partner["endpoint_url"]}${link}`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,

          "Content-Type": contentType,
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          this.createTransaction({
            system_confirmed: 1,
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async selectFile(event) {
      this.data["photo"] = await event.target.files[0];
      this.send();
    },
  },
  data() {
    return {
      resendData: false,
      job_id: null,
      log_id: null,
      data: {
        photo: null,
        loan_id: null,
      },
    };
  },
};
</script>

